import useHistoryTableFilterStore from 'src/stores/historyTableFilterStore/useHistoryTableFilterStore';
import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';
import PortfolioHistoryTableMarketFilter from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableMarketFilter';

export default function PortfolioHistorySettledTableControls() {
	const marketFilter = useHistoryTableFilterStore(
		(s) => s.getFilterState('settled-balances')['marketSymbol']
	);
	const setHistoryTableFilterState = useHistoryTableFilterStore((s) => s.set);

	const handleMarketFilterChange = (selectedMarket: string) => {
		setHistoryTableFilterState((s) => {
			s['settled-balances'].marketSymbol = selectedMarket;
			s['settled-balances'].currentUiPage = 0;
		});
	};

	return (
		<PortfolioHistoryTableControls
			historyType="settled-balances"
			exportType="settle-pnl-records"
		>
			<PortfolioHistoryTableMarketFilter
				marketType="perp"
				marketFilter={marketFilter}
				handleMarketFilterChange={handleMarketFilterChange}
				id="portfolio-history-settled-table-market-filter"
			/>
		</PortfolioHistoryTableControls>
	);
}
